/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsPendingTransaction
 */
export interface MelcoModelsPendingTransaction {
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsPendingTransaction
     */
    subscription_start_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsPendingTransaction
     */
    old_license_count?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsPendingTransaction
     */
    new_license_count?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsPendingTransaction
     */
    old_sub_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsPendingTransaction
     */
    new_sub_type?: string | null;
}

export function MelcoModelsPendingTransactionFromJSON(json: any): MelcoModelsPendingTransaction {
    return MelcoModelsPendingTransactionFromJSONTyped(json, false);
}

export function MelcoModelsPendingTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsPendingTransaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subscription_start_date': !exists(json, 'subscription_start_date') ? undefined : (new Date(json['subscription_start_date'])),
        'old_license_count': !exists(json, 'old_license_count') ? undefined : json['old_license_count'],
        'new_license_count': !exists(json, 'new_license_count') ? undefined : json['new_license_count'],
        'old_sub_type': !exists(json, 'old_sub_type') ? undefined : json['old_sub_type'],
        'new_sub_type': !exists(json, 'new_sub_type') ? undefined : json['new_sub_type'],
    };
}

export function MelcoModelsPendingTransactionToJSON(value?: MelcoModelsPendingTransaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subscription_start_date': value.subscription_start_date === undefined ? undefined : (value.subscription_start_date.toISOString()),
        'old_license_count': value.old_license_count,
        'new_license_count': value.new_license_count,
        'old_sub_type': value.old_sub_type,
        'new_sub_type': value.new_sub_type,
    };
}


